module.exports = __webpack_public_path__ + "assets/checkmark_green-0dcc74.svg";